import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert } from 'react-bootstrap';
import { GoogleLogin } from '@react-oauth/google';
import './AdminLogin.css';

const AdminLogin = ({ onLogin }) => {
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            //const response = await fetch('http://localhost:5000/api-portal/google-login', {
            const response = await fetch('/api-portal/google-login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token: credentialResponse.credential }),
            });

            const data = await response.json();

            if (data.success) {
                sessionStorage.setItem('adminToken', data.token);
                onLogin(true);
                navigate('/admin-dashboard');
            } else {
                setError(data.message || 'Access denied. Authorized personnel only.');
            }
        } catch (err) {
            setError('Server connection failed. Is the backend running?');
        }
    };

    return (
        <div className="admin-login-page">
            <Container className="d-flex justify-content-center align-items-center h-100">
                <div className="login-card text-center animate-in">
                    <div className="mb-4">
                        <h2 className="login-title">LEVEL 9 CO. <span className="red-text">ADMIN</span></h2>
                        <p className="text-muted small">Learning Management Operations</p>
                    </div>

                    {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}

                    <div className="d-flex justify-content-center mt-4">
                        <GoogleLogin
                            onSuccess={handleGoogleSuccess}
                            onError={() => setError('Google Login Failed')}
                            theme="filled_black"
                            shape="pill"
                        />
                    </div>

                    <div className="mt-5 access-footer">
                        <p className="mb-1 text-uppercase fw-bold text-secondary" style={{ fontSize: '10px', letterSpacing: '2px' }}>
                            Authorized Personnel Only
                        </p>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default AdminLogin;